import { StylesClasses, createStyles } from '@utils/styles'

const styles = createStyles({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    width: 'fit-content',
  },
  icon: {
    height: '52px',
    width: '52px',
    alignSelf: 'start',
    '& img': {
      objectFit: 'contain !important',
    },
  },
  mobileIconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '4px',
    height: 'auto',
    width: 'auto',
    borderRadius: 0,
    backgroundColor: 'transparent',
  },
  mobileIcon: {
    height: '52px',
    width: '52px',
    '& img': {
      objectFit: 'contain !important',
    },
  },
  title: {
    whiteSpace: 'pre',
  },
  starsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '2px',
    marginTop: '4px',
  },
  halfStar: {
    position: 'relative',
    overflow: 'hidden',
    width: '12px',
    '& svg': {
      position: 'absolute',
      left: 0,
      top: 0,
    },
  },
  ratingInfo: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '4px',
    alignSelf: 'flex-end',
    marginTop: '-4px',
  },

  reviewCount: {
    color: 'text.secondary',
    whiteSpace: 'pre',
  },
})

export type StyleClassNames = StylesClasses<typeof styles>

export default styles
